module.exports = __webpack_public_path__ + "img/hfg_of110122_02k.bc52faa1.jpg";